import React from 'react';
import {interpolateRgb} from 'd3-interpolate';
import {quantile} from 'd3-array';

const SimilarNeighborhoodsList = ({active_mode, active_neighborhood, neighborhoods, neighborhoods_samples, formatters, active_price, active_probability, active_year, setActiveNeighborhood}) => {

  const handleClick = (neighborhood) => {
    setActiveNeighborhood(neighborhood.properties.neighborhood);
  }

  let neighborhoods_with, neighborhoods_for_display, title, neighborhood_item;
  if (active_mode === 'Chance') {
    let interpolate = (value) => {
      if (value < 0.5) {
        return interpolateRgb('#d01c8b','#f7f7f7')(value * 2);
      } else if (value > 1) {
        return '#4dac26';
      } else {
        return interpolateRgb('#f7f7f7','#4dac26')((value - 0.5) * 2);
      }
    }

    title = <div>Similar Neighborhoods (within 5%)</div>
    neighborhoods_with = neighborhoods.map((neighborhood,i) => {
      const year_samples = neighborhoods_samples[i];
      let below_price_counter = 0;
      for (let sample of year_samples) {
        if (sample <= active_price) {
          below_price_counter++
        }
      }
      const probability = below_price_counter/year_samples.length;
      const neighborhood_probability = probability;
      const ranking_difference = Math.abs(neighborhood_probability - active_neighborhood.properties.probability);
      neighborhood.properties.list_probability = neighborhood_probability;
      neighborhood.properties.ranking_difference = ranking_difference;
      return neighborhood;
    });
    neighborhoods_with.sort((a,b) => {
      if (a.properties.ranking_difference <= b.properties.ranking_difference)
        return -1;
      if (a.properties.ranking_difference > b.properties.ranking_difference)
        return 1;
      return 0;
    })

    neighborhoods_for_display = neighborhoods_with.filter((neighborhood) => (neighborhood.properties.ranking_difference < 0.05) ? true : false);
    neighborhoods_for_display.splice(0,1);

    neighborhood_item = (neighborhood) => {
      return <div className="clearfix SideListItem tnum h6 col-12 px1"
        key={neighborhood.properties.neighborhood}
        style={{background: interpolate(neighborhood.properties.list_probability)}}
        onClick={handleClick.bind(this, neighborhood)}
      >
        <div className='relative'>
          <div className="">
            {neighborhood.properties.neighborhood}, <span className="capitalize">{neighborhood.properties.borough}</span>
          </div>
          <div className="absolute right-0 top-0">
            <span style={{color: 'rgba(0,0,0,0.5)'}}>{formatters.percentFormat(neighborhood.properties.list_probability - active_neighborhood.properties.probability)}</span>
            &nbsp;
            {formatters.percentFormat(neighborhood.properties.list_probability)}
          </div>
        </div>
      </div>
    }
  } else {
    let interpolate = (value) => {
      if (value < 0.5) {
        return interpolateRgb('#5e3c99','#f7f7f7')(value * 2);
      } else if (value > 1) {
        return '#e66101';
      } else {
        return interpolateRgb('#f7f7f7','#e66101')((value - 0.5) * 2);
      }
    }

    title = <div>Similar Neighborhoods</div>
    neighborhoods_with = neighborhoods.map((neighborhood,i) => {
      const year_samples = neighborhoods_samples[i];
      let price = Math.round(quantile(year_samples, active_probability));
      const neighborhood_price = price;
      const ranking_difference = Math.abs(neighborhood_price - active_neighborhood.properties.price);
      neighborhood.properties.list_price = neighborhood_price;
      neighborhood.properties.ranking_difference = ranking_difference;
      return neighborhood;
    });
    neighborhoods_with.sort((a,b) => {
      if (a.properties.ranking_difference <= b.properties.ranking_difference)
        return -1;
      if (a.properties.ranking_difference > b.properties.ranking_difference)
        return 1;
      return 0;
    })

    neighborhoods_for_display = neighborhoods_with.filter((neighborhood) => (neighborhood.properties.ranking_difference < 100000) ? true : false);
    neighborhoods_for_display.splice(0,1);

    neighborhood_item = (neighborhood) => {
      return <div className="clearfix SideListItem tnum h6 col-12 px1"
        key={neighborhood.properties.neighborhood}
        style={{background: interpolate(neighborhood.properties.list_price/2000000)}}
        onClick={handleClick.bind(this, neighborhood)}
      >
        <div className='relative'>
          <div className="">
            {neighborhood.properties.neighborhood}, <span className="capitalize">{neighborhood.properties.borough}</span>
          </div>
          <div className="absolute right-0 top-0">
            <span style={{color: 'rgba(0,0,0,0.5)'}}>{formatters.dollarShort(neighborhood.properties.list_price - active_neighborhood.properties.price)}</span>
            &nbsp;
            {formatters.dollarShort(neighborhood.properties.list_price)}
          </div>
        </div>
      </div>
    }
  }

  return (
    <div>
      <div className="h5 relative clearfix">
        <div className="left px2">
          {title}
        </div>
        <div className="right">
          {neighborhoods_for_display.length}
        </div>
      </div>
      {neighborhoods_for_display.map((neighborhood) =>
        neighborhood_item(neighborhood)
      )}
    </div>
  )
}

export default SimilarNeighborhoodsList;


/** WEBPACK FOOTER **
 ** ./src/components/SimilarNeighborhoodsList.js
 **/